import styled from 'styled-components';
import './theme';
import { typographyMixin } from './typographyMixin.js';
/** `Typography` is responsible for styling the text according to the designs */
export const Typography = styled.div.attrs((props) => ({
    'data-test': props['data-test'] ?? 'typography',
})) `
  ${typographyMixin};
`;
Typography.defaultProps = {
    size: 'sm',
    type: 'regular',
};
//# sourceMappingURL=Typography.js.map